import { Layout } from "lucide-react";
import CustomerDashboard from "./CustomDashboard";
import React from "react";
import LayoutHOC from "../../LayoutHOC";
import { useLocation, useParams } from "react-router-dom";
import RedirectModulePreview from "./RedirectModulePreview";

function PreviewWrapper() {
  const { leadTypePath: templateId } = useParams();
  const location = useLocation();
  const recordData = location.state?.recordData || {};
  const useSearchParams = new URLSearchParams(window.location.search);
  // const rowId = useSearchParams.get("record");
  // const coreId = useSearchParams.get("core");

  console.log("PreviewWrapper recordData:", recordData, templateId);

  return (
    <div className="px-2 h-full">
      {recordData && templateId && (
        <RedirectModulePreview propTemplateId={templateId} isCompanyLevel={true} rowData={recordData} />
      )}
    </div>
  );
}

export default LayoutHOC(PreviewWrapper);
